<script setup lang="ts">
import { Breakpoints } from '@collector/shared-ui'
import MainSummary from '@desktop/views/Relation/components/RelationView/Main/MainSummary/MainSummary.vue'

import Aside from './Aside/Aside.vue'

interface Props {
  asideBreakpoint?: Extract<Breakpoints, 'xs' | 'sm'>
}

withDefaults(defineProps<Props>(), {
  asideBreakpoint: 'xs',
})

/**
 * Tailwind classes using container breakpoints with `:` (e.g., `@sm:flex-row`)
 * must be hardcoded. Dynamic expressions for breakpoint values are not recognized
 * by Tailwind's class scanner.
 */
</script>

<template>
  <div
    class="flex min-h-0 flex-1 flex-col gap-x-[clamp(0.25rem,1vw,1rem)] gap-y-6"
    :class="{
      '@sm:flex-row': asideBreakpoint === 'sm',
      '@xs:flex-row': asideBreakpoint === 'xs',
    }"
  >
    <div class="flex-gap-y-fluid min-h-0 w-full min-w-min overflow-y-auto">
      <slot name="main">
        <MainSummary />
      </slot>
    </div>
    <Aside
      class="mb-6 w-full"
      :class="{
        '@sm:mb-0 @sm:w-[52%]': asideBreakpoint === 'sm',
        '@xs:mb-0 @xs:w-[54%]': asideBreakpoint === 'xs',
      }"
    />
  </div>
</template>
